import { AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, computed, input, output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { warnDeveloper } from '@app/functions/warn-developer';
import { map, tap } from 'rxjs/operators';

/**
 * Renders the SVG image as HTML in the DOM
 */
@Component({
    selector: 'app-svg-image',
    standalone: true,
    imports: [AsyncPipe],
    styles: `
        :host {
            display: contents;
        }
    `,
    template: `@if (svgImage() | async; as image) {
        <div [outerHTML]="image"></div>
    }`,
})
export class SVGImageComponent {
    /**
     * the URL for the SVG file, must begin with "assets/..."
     */
    url = input.required<string>();

    /**
     * onLoad event emits when the image has been fetched and the safeHTML has been generated
     */
    onLoad = output();

    svgImage = computed(() => {
        // Because we use bypassSecurityTrustHtml we never want to be rendering an external SVG, therefore this check is in place as a safeguard
        if (!this.url().startsWith('assets')) {
            warnDeveloper([
                'app-svg-image can only be used with internal SVG assets (located within the assets folder). If you need to render an SVG from an external address, use an img tag.',
            ]);
            return;
        }
        return this.httpClient.get(`${window.location.origin}/${this.url()}`, { responseType: 'text' }).pipe(
            map((img) => this.sanitizer.bypassSecurityTrustHtml(`${img}`)),
            tap(() => this.onLoad.emit())
        );
    });

    constructor(
        private httpClient: HttpClient,
        private sanitizer: DomSanitizer
    ) {}
}
